import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { MarvColorPrimary } from '@marv/types';
import { MarvSelectComponent, MarvSelectItem } from '@marv/components';

@Component({
    selector: 'marv-week-day-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    imports: [forwardRef(() => MarvSelectComponent)]
})
export class MarvWeekDaySelectComponent  implements OnInit {

    @Input({alias : 'label', required : false}) labelSelect: string = this.translateService.instant('STORE');
    @Input({alias : 'icon', required : false}) iconSelect: string = 'storefront-outline';
    @Input({alias : 'formName', required : false}) formName: string|number = 'storeId';
    @Input({alias : 'errorText', required : false}) errorText: string = this.translateService.instant('MSG_ERROR_SELECT_MANDATORY');
    @Input({alias : 'disabled', required : false}) disabled: boolean = false;
    @Input({alias : 'multiple', required : false}) multiple: boolean = false; 
    @Input({alias : 'displayItemsSelected', required : false}) displayItemsSelected: boolean = false;
    @Input({alias : 'withSpeechToText', required : false}) withSpeechToText: boolean = false;
    
    days: Array<MarvSelectItem> = [
        {label: this.translateService.instant('DAY_MONDAY'), value: 1, color: MarvColorPrimary},
        {label: this.translateService.instant('DAY_TUESDAY'), value: 2, color: MarvColorPrimary},
        {label: this.translateService.instant('DAY_WEDNESDAY'), value: 3, color: MarvColorPrimary},
        {label: this.translateService.instant('DAY_THURSDAY'), value: 4, color: MarvColorPrimary},
        {label: this.translateService.instant('DAY_FRIDAY'), value: 5, color: MarvColorPrimary},
        {label: this.translateService.instant('DAY_SATERDAY'), value: 6, color: MarvColorPrimary},
        {label: this.translateService.instant('DAY_SUNDAY'), value: 7, color: MarvColorPrimary},
    ];

    constructor(
        public translateService: TranslateService
    ) { }

    ngOnInit() {}
    
}
